export const productCategories = [
  { id: 'all', name: 'Tümü' },
  { id: 'profil-sistemleri', name: 'Profil Sistemleri' },
  { id: 'yapi-malzemeleri', name: 'Yapı Malzemeleri' },
  { id: 'lojistik', name: 'Lojistik' }
];

export const products = [
  {
    id: 1,
    slug: 'tavan-u-strong',
    name: 'Tavan U STRONG',
    category: 'profil-sistemleri',
    image: '/images/1-2.png',
    description:
      'KUS GRUP tarafından geliştirilen Tavan U STRONG profili, sac yüzeyine uygulanan özel nokta baskı formu ile standart profillere kıyasla daha yüksek vida tutma performansı, kolay montaj ve artırılmış dayanım sağlayarak projelerinize güvenilir bir çözüm sunar.',
    advantages: [
      'Daha iyi vida tutma',
      'Daha kolay montaj',
      'Daha kolay vidalama',
      'Daha yüksek mukavemet',
      'Standart profillere göre daha güçlü yapı'
    ],
    specs: [
      ['Ürün Adı', 'Tavan U STRONG'],
      ['Ürün Kodu', 'TU.STRONG.068'],
      ['Kalınlık', '0,30 / 0,35 / 0,40 / 0,45 mm'],
      ['Boy', '3000 mm (Özel ölçü üretilir)'],
      ['Paket İçeriği', '24 Adet'],
      ['Palet İçeriği', '60 Paket / 1440 Adet'],
      ['Kaplama', 'DX51 / Z 70-200 (Galvaniz)']
    ],
    detail: { width: '28 mm', height: '20 mm' }
  },
  {
    id: 2,
    slug: 'duvar-u-strong',
    name: 'Duvar U STRONG',
    category: 'profil-sistemleri',
    image: '/images/1-3.png',
    description:
      'Duvar U STRONG profilleri, bölme duvar uygulamalarında yüksek ölçü stabilitesi ve güçlü bağlantı performansı için tasarlanmıştır.',
    advantages: [
      'Yüksek bağlantı dayanımı',
      'Kolay ve hızlı montaj',
      'Düzgün yüzey hattı',
      'Standartlara uygun üretim',
      'Projeye göre ölçü esnekliği'
    ],
    specs: [
      ['Ürün Adı', 'Duvar U STRONG'],
      ['Ürün Kodu', 'DU.STRONG.075'],
      ['Kalınlık', '0,35 / 0,40 / 0,45 / 0,50 mm'],
      ['Boy', '3000 mm (Özel ölçü üretilir)'],
      ['Paket İçeriği', '24 Adet'],
      ['Palet İçeriği', '60 Paket / 1440 Adet'],
      ['Kaplama', 'DX51 / Z 70-200 (Galvaniz)']
    ],
    detail: { width: '30 mm', height: '27 mm' }
  },
  {
    id: 3,
    slug: 'kaba-siva-profili',
    name: 'Kaba Sıva Profili',
    category: 'profil-sistemleri',
    image: '/images/1-1.png',
    description:
      'Kaba sıva profilleri, sıva uygulamalarında düzgün yüzey, net köşe ve kontrollü uygulama kalitesi sağlamak için kullanılır.',
    advantages: [
      'Düzgün mastar hattı',
      'Kolay uygulama',
      'Yüzey kalitesini artırır',
      'Galvaniz kaplama avantajı',
      'Uygulama süresini kısaltır'
    ],
    specs: [
      ['Ürün Adı', 'Kaba Sıva Profili'],
      ['Ürün Kodu', 'KS.PROFIL.030'],
      ['Kalınlık', '0,30 / 0,35 / 0,40 mm'],
      ['Boy', '2700 / 3000 mm'],
      ['Paket İçeriği', '50 Adet'],
      ['Palet İçeriği', 'Projeye göre planlanır'],
      ['Kaplama', 'Galvaniz']
    ],
    detail: { width: '35 mm', height: '10 mm' }
  },
  {
    id: 4,
    slug: 'cati-paneli',
    name: 'Çatı Paneli',
    category: 'yapi-malzemeleri',
    image: '/images/kusgrup.png',
    description:
      'Yüksek kaliteli çatı paneli, dayanıklı malzemeden üretilmiş uzun ömürlü bir yapı çözümüdür.',
    advantages: ['Yüksek dayanıklılık', 'Su geçirmez yapı', 'Kolay montaj', 'Isı yalıtımı'],
    specs: [
      ['Ürün Adı', 'Çatı Paneli'],
      ['Ürün Kodu', 'KG-CP-100'],
      ['Kullanım Alanı', 'Endüstriyel ve konut projeleri'],
      ['Kaplama', 'Projeye göre'],
      ['Teslimat', 'Proje bazlı planlama']
    ],
    detail: { width: 'Proje', height: 'Özel' }
  },
  {
    id: 5,
    slug: 'ahsap-palet',
    name: 'Ahşap Palet',
    category: 'lojistik',
    image: '/images/gebzepalet.png',
    description:
      'Dayanıklı ahşap paletler, lojistik ve depolama ihtiyaçları için güvenilir taşıma çözümleri sunar.',
    advantages: ['Yüksek taşıma kapasitesi', 'Dayanıklı malzeme', 'İstifleme kolaylığı', 'Standart ölçüler'],
    specs: [
      ['Ürün Adı', 'Ahşap Palet'],
      ['Ürün Kodu', 'GP-AH-STD'],
      ['Ölçü', 'Standart ve özel ölçü'],
      ['Kullanım', 'Depolama ve lojistik'],
      ['Teslimat', 'Adet bazlı planlama']
    ],
    detail: { width: 'Özel', height: 'Özel' }
  }
];
